/* eslint-disable @typescript-eslint/no-explicit-any */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo } from 'react';
import { trackAmplitudeEvent } from '../../../../../thirdPartyTracking/amplitude';
import { Text, Switch, Tooltip, Icon, icons, Flex } from '@tapresearch/ui/components';
import { Tooltips } from '../../../../../../shared/Tooltip/Tooltip.styled';
import { ResponsiveLineChart } from './ResponsiveLineChart';
import { CHART_CONTROL_TYPES } from './CustomControlLegend';
export function ResponsiveRatingLineChartSwitch(param) {
    var isChecked = param.isChecked, onChange = param.onChange, answersCount = param.answersCount;
    return /*#__PURE__*/ React.createElement(Flex, {
        mr: 12,
        pt: 4,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Tooltip, _object_spread_props(_object_spread({}, Tooltips.Base), {
        label: 'This toggle groups your top 2 & bottom 2 answers into their own lines on the graph. When there are 5 or more answers you will also see a line for all answers between top and bottom. Turn toggle off to see all individual answers.',
        shouldWrapChildren: true,
        fontSize: "md",
        placement: "left-start"
    }), /*#__PURE__*/ React.createElement(Icon, {
        wrapAs: Flex,
        icon: icons.md.InfoOutline,
        boxSize: 4,
        color: "gray.500",
        mr: 1
    })), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Text, {
        fontSize: "sm",
        mr: 4
    }, "Group answers:"), /*#__PURE__*/ React.createElement(Switch, {
        isChecked: isChecked,
        onChange: trackAmplitudeEvent(onChange, {
            eventType: 'groupAnswers'
        }),
        isDisabled: answersCount < 5
    })));
}
export function ResponsiveRatingLineChart(param) {
    var data = param.data, waves = param.waves, legendDirection = param.legendDirection, customLegendControlProps = param.customLegendControlProps, usePercentage = param.usePercentage;
    var sortedData = useMemo(function() {
        return legendDirection === 'row' // Rating chart is ungrouped when direction is set to row
         ? _to_consumable_array(data).sort(function(a, b) {
            // Ensure the legend is ordered low-to-high
            return parseInt(a.id) - parseInt(b.id);
        }) : data;
    }, [
        data,
        legendDirection
    ]);
    return /*#__PURE__*/ React.createElement(ResponsiveLineChart, _object_spread_props(_object_spread({
        data: sortedData,
        waves: waves,
        usePercentage: usePercentage,
        customLegendControlProps: customLegendControlProps,
        customLegendType: CHART_CONTROL_TYPES.RATING_SCALE_GROUP_ANSWERS
    }, legendDirection && {
        legendDirection: legendDirection
    }), {
        colorScheme: 'red_blue'
    }));
}
